import { Search } from '@/DTOS/ProviderWorkPlace/Search';
import request from '../../utils/request';

const providerWorkPlaceService = {
  search: (search: Search) => {
    return request('/providerWorkPlace/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    id: any,
    formData: {
      providerId: any;
      name: any;
      address: any;
      details: any;
    }
  ) => {
    return request('/providerWorkPlace/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          providerId: formData.providerId,
          name: formData.name,
          address: formData.address,
          details: formData.details,
        },
      }),
    });
  },
};

export default providerWorkPlaceService;
